const ActionTypes = {
    HideModal: 1,
    ShowModal: 2,
  }
  
  export default ActionTypes